// Single source of truth for the £79 event activation price.
// Lives outside any page component so SetupEvent, SetupPayment, and the
// shared AppliedCodeBanner all import the same number.
export const FULL_PRICE_PENCE = 7900;

export function formatGBP(pence: number): string {
  return `£${(pence / 100).toFixed(2)}`;
}
